import { render, staticRenderFns } from "./CreateClientGroupView.vue?vue&type=template&id=6de8c498&scoped=true&"
import script from "./CreateClientGroupView.vue?vue&type=script&lang=js&"
export * from "./CreateClientGroupView.vue?vue&type=script&lang=js&"
import style0 from "./CreateClientGroupView.vue?vue&type=style&index=0&id=6de8c498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8c498",
  null
  
)

export default component.exports